import {EventEmitter} from '@angular/core';
import {ResponseDto} from './dto/ResponseDto';

export class LocalRecipient {
    constructor(
        public messageReceived: EventEmitter<ResponseDto>,
        public startTyping: EventEmitter<ResponseDto>
    ) {
    }
}
